/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Payment_Failed_TitleInputs */



/**
* | output |
* | --- |
* | "Payment failed" |
*
* @param {Subscription_Payment_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const subscription_payment_failed_title = /** @type {((inputs?: Subscription_Payment_Failed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Payment_Failed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlung fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Payment failed")
});